import { Enum } from "../../types/types";

export const RegisterPageLocators = Enum(
  "register_select_country",
  "register_input_email",
  "register_input_firstname",
  "register_input_lastname",
  "register_input_username",
  "register_input_displayName",
  "register_input_password",
  "register_datePicker_dateOfBirth",
  "register_checkbox_subscribe",
  "register_checkbox_required_policy",
  "register_checkbox_optional_policy",
  "register_checkbox_posAndTosAgreement",
  "register_country_requirements_loading",
  "register_country_requirements_error",
  "register_country_requirements_retry",
  "register_text_submission_invalidated",
  "register_button_submit"
);
